import { getApiClient } from "@punchup/utils/apiRegistry";
import { logException } from "@punchup/sentry";

export interface ManagerAuditLogEntry {
  id: string;
  created_at: string;
  user_id: string;
  user_email: string;
  action: string;
  resource_type: string;
  resource_id: string | null;
  http_method: string;
  route_path: string;
  comedian_id: string | null;
  venue_page_id: string | null;
  is_super_admin: boolean;
  user_agent: string | null;
  environment: string;
  metadata: Record<string, unknown> | null;
}

export interface ManagerAuditLogResponse {
  logs: ManagerAuditLogEntry[];
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export interface FetchManagerAuditLogParams {
  limit?: number;
  offset?: number;
  userEmail?: string;
  action?: string;
  resourceType?: string;
  resourceId?: string;
  comedianId?: string;
  venuePageId?: string;
}

export async function fetchManagerAuditLog(
  params: FetchManagerAuditLogParams = {}
): Promise<ManagerAuditLogResponse> {
  try {
    const searchParams = new URLSearchParams();

    searchParams.set("limit", (params.limit ?? 50).toString());
    searchParams.set("offset", (params.offset ?? 0).toString());

    if (params.userEmail) searchParams.set("userEmail", params.userEmail);
    if (params.action) searchParams.set("action", params.action);
    if (params.resourceType)
      searchParams.set("resourceType", params.resourceType);
    if (params.resourceId) searchParams.set("resourceId", params.resourceId);
    if (params.comedianId) searchParams.set("comedianId", params.comedianId);
    if (params.venuePageId) searchParams.set("venuePageId", params.venuePageId);

    const url = `/api/v2/internal/manager-audit-log?${searchParams.toString()}`;
    const response = await getApiClient().get<{
      data: { logs: ManagerAuditLogEntry[] };
      metadata: {
        total: number;
        limit: number;
        offset: number;
        hasMore: boolean;
      };
    }>(url);

    return {
      logs: response.data.logs,
      total: response.metadata.total,
      limit: response.metadata.limit,
      offset: response.metadata.offset,
      hasMore: response.metadata.hasMore,
    };
  } catch (error) {
    logException(error, {
      tags: { action: "fetchManagerAuditLog" },
    });
    throw error;
  }
}
